<script setup>
import { ref, computed,  } from 'vue';
import { useSertStore } from '@/stores/sertStore';
import { getCertificate, token } from '@/utils/services';
import SertHeader from '@/components/blocks/SertHeader.vue';

const storeSert = useSertStore();

const isDisabled = computed(() => !storeSert.disabledButtons.sumBtn);

const parametrs = computed(() => ({
  cover: storeSert.checkedItems.imageId,
  recipient_name: storeSert.checkedItems.userName,
  congratulation_text: storeSert.checkedItems.message,
  denomination: storeSert.checkedItems.sum,
  session_token: token.value
}))

const sendCertificateInformation = async () => {
    if (!token.value) {
        await getCertificate(parametrs, true) 
    } else if (storeSert.certificateChanged) {
        await getCertificate(parametrs) 
    } else {
        console.log('Данные сертификата не изменялись — запрос не отправлен.')
    }
}
</script>
<template>
    <div class="constructor">
        <div class="constructor__body">
            <SertHeader :white-steps="4">
                <template #title>Предварительный просмотр</template>
                <template #text>Убедитесь, что все данные верны и дизайн соответствует вашим ожиданиям.</template>
            </SertHeader>            
            <ul class="preview-list">
                <li>Проверьте все данные: сумма, имя получателя, персональное сообщение и дизайн.</li>
                <li>Если все верно, нажмите ‘Далее’ для перехода к заполнению данных и оплате.</li>
            </ul>
        </div>
        <div class="constructor__btns">
            <a 
                :href="`#${storeSert.screens.sum}`" 
                @click="storeSert.goToScreen(storeSert.screens.sum)" 
                class="btn --black">
                Назад
            </a>
            <a                    
                :href="`#${storeSert.screens.pay}`" 
                @click="storeSert.goToScreen(storeSert.screens.pay), sendCertificateInformation()" 
                class="btn --full"
                :class="{ disabled: isDisabled }">
                Далее
            </a>
        </div>
    </div>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
</style>